import React from 'react';

interface LoadingSpinnerProps {
  /** Messaggio da mostrare sotto lo spinner */
  message?: string;
  /** Dimensione dello spinner */
  size?: 'small' | 'medium' | 'large';
  /** Classe CSS personalizzata */
  className?: string;
}

/**
 * Componente LoadingSpinner riutilizzabile
 * Mostra un indicatore di caricamento standardizzato
 */
export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = 'Caricamento dati...',
  size = 'medium',
  className = ''
}) => {
  const sizeClasses = {
    small: 'loading-spinner-small',
    medium: 'loading-spinner-medium', 
    large: 'loading-spinner-large'
  };

  return (
    <div className={`loading-container ${className}`}>
      <div className={`loading-spinner ${sizeClasses[size]}`} 
           role="status" 
           aria-label="Caricamento in corso">
        <span className="sr-only">Caricamento...</span>
      </div>
      {message && <p className="loading-message">{message}</p>}
    </div>
  );
};

export default LoadingSpinner;